import { shuffle, slice } from 'lodash'
import moment from 'moment'
import { Invite } from '@/models'
import Learners from '~data/generated-learners.json'
import Advisors from '~data/generated-advisors.json'

export default {
  data () {
    return {
      // Hard coded invites for fake invites
      fakeRequiredActionInvites: [
        new Invite({
          for: 'jenn.smith@yahoo.com',
          forFirstName: 'Jenn',
          forLastName: 'Smith',
          validUntil: moment().add(2, 'days'),
          claimedBy: null
        }),
        new Invite({
          for: null,
          forFirstName: 'Fred',
          forLastName: 'Thomas',
          validUntil: moment().add(8, 'days'),
          claimedBy: null
        })
      ]
    }
  },
  computed: {
    /**
     * List of fake invites to be displayed on the learner page
     * @return {*[Invite]}
     */
    demoInvites () {
      const learners = slice(shuffle(Learners), 0, 5)
      const advisors = slice(shuffle(Advisors), 0, 3)
      let reviewKintellCardInvite = learners.pop()
      reviewKintellCardInvite.pendingKintellCard = {
        kintellCardId: '29029020209092',
        slug: 'image-branding',
        status: 'awaiting-review',
        user: { slug: 'joy-karen' }
      }
      reviewKintellCardInvite = new Invite(reviewKintellCardInvite)
      advisors[1].claimedByUser.invites = [ learners.pop(), advisors.pop() ]
      const invites = [ ...learners, ...advisors ].map(invite => new Invite(invite))
      return [ reviewKintellCardInvite, ...this.fakeRequiredActionInvites, ...shuffle(invites) ]
    }
  },
}
